import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=fc97013e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=fc97013e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc97013e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc97013e')) {
      api.createRecord('fc97013e', component.options)
    } else {
      api.reload('fc97013e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=fc97013e&scoped=true&", function () {
      api.rerender('fc97013e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ol8N4oJmbtnX/JS/teamMember.vue"
export default component.exports